
import ProductOptions from './ProductOptions'
import VariantList from './VariantList'

export default {
  components: {
    ProductOptions,
    VariantList
  },
  props: {
    product: {
      type: Object,
      default: null
    },
    type: {
      type: String,
      default: 'form'
    },
    compact: {
      type: Boolean,
      default: true
    },
    availability: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      variant: null
    }
  },
  computed: {
    hasOptions() {
      const { variantsCount, variants } = this.product
      return variantsCount > 0 || (variants && variants.length)
    },
    available() {
      return this.variant.totalOnHand > 0
    },
    backorderable() {
      return this.variant.totalOnHand < 1 && this.product.backorderable
    },
    fewLeft() {
      return this.available && this.variant.totalOnHand < 10
    },
    messageContent() {
      let title = this.$t('eshop.inStock')
      let type = 'success'

      if (!this.available) {
        title = this.$t('eshop.soldOut')
        type = 'error'
      }

      if (this.backorderable) {
        title = `${this.$t('eshop.soldOut')} / ${this.$t('eshop.backorder')}`
        type = 'warning'
      }

      if (this.fewLeft) {
        title = this.$t('eshop.fewLeft')
        type = 'info'
      }

      return {
        title,
        type
      }
    },
    showAlert() {
      if (this.type == 'form') {
        return this.availability && (this.variant && this.hasOptions)
      } else {
        return false
      }
    }
  },
  methods: {
    onSetVariant(variant) {
      this.variant = variant
      this.$emit('set-variant', variant)
    }
  }
}
